<template>
  <div class="tile is-vertical">
    <div class="card">
      <div class="card-content">
        <p>Para cualquier información, ayuda y/o sugerencia referente al juego por favor enviar un mensaje al siguiente correo electrónico:</p>
        <a v-clipboard:copy="email" v-clipboard:success="copyEmail" class="card-footer-item">{{email}}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:'ContactPage',
  beforeCreate(){
    this.$store.dispatch('setPage', {
      location:{name:'contact',number:3},
      title:'contacto',
      breadcrumb:[
        {name:'inicio',link:this.$store.state.baseUrl,active:true, icon:'home'},
        {name:'contacto',link:'/contacto',active:false, icon:'location-arrow'}
      ]
    })
  },
  data:() => ({
    email: 'soporte@mucrisis.com'
  }),
  methods: {
    copyEmail() {
        this.$toasted.show("¡El correo se ha copiado en el portapapeles!", { 
          theme: "toasted-primary", 
          position: "bottom-right", 
          duration : 2500,
          icon : {
            name : 'info-circle'
          }
        })
    }
  }
}
</script>

<style>

</style>
